import {Flex} from "antd";
import React, {CSSProperties} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";

export const ElementInfo = (props: {
    style?: CSSProperties,
    element: { x: number, y: number, z: number, scale: number }
}) => {

    return (

        <Flex style={{
            ...props.style,
            borderRadius: 10,
            background: 'rgba(255,255,255,0.5)',
            zIndex: 1000,
            position: 'absolute',
            top: 10,
            left: 10,
            padding: '0 10px',
            fontSize: 12,
        }}
              gap={6}
              align={'center'}>
            <span>x: {Math.round(props.element?.x)}</span>
            <span>y: {Math.round(props.element?.y)}</span>
            <span>z: {Math.round(props.element?.z)}</span>
            <span><FontAwesomeIcon icon={faMagnifyingGlass} size={'2xs'}/>: {props.element?.scale || 1}</span>
        </Flex>
    )
}